<template>
  <MDBContainer>
    <MDBModal
      id="enemyInfo"
      tabindex="-1"
      labelledby="enemyID"
      v-model="enemyInfo"
      scrollable
      size="xl"
      @update:modelValue="updateEmit"
    >
      <MDBModalHeader>
        <MDBModalTitle id="enemyID">
          <h5 id="name">
            {{ info0.name }}
            <div style="font-size: 60%">{{ enemy2 }}</div>
          </h5>
        </MDBModalTitle>
      </MDBModalHeader>
      <MDBModalBody>
        <el-select v-model="enemy2">
          <el-option
            v-for="dupe in duplicateEnemies"
            :key="dupe[0]"
            :label="dupe[0]"
            :value="dupe[0]"
          >
          </el-option>
        </el-select>
        <hr />
        <router-link :to="'/enemy/' + enemy2">To Enemy Page</router-link>
        <MDBRow class="row-cols-1 row-cols-lg-2 my-4">
          <MDBCol>
            <div class="image">
              <img :src="'images/profile/' + info0.img + '.png'" />
            </div>
            <MDBRow class="row-cols-2 my-2">
              <MDBCol class="border"><strong>Type</strong></MDBCol>
              <MDBCol class="border"
                ><strong>{{ info0.type }}</strong></MDBCol
              >
              <MDBCol class="border"><strong>Role</strong></MDBCol>
              <MDBCol class="border"
                ><strong>{{ info0.role }}</strong></MDBCol
              >
            </MDBRow>
            <div class="LVL">
              <MDBInput
                label="Level Input"
                type="number"
                v-model.number="level"
              />
            </div>
          </MDBCol>
          <MDBCol>
            <MDBRow class="row-cols-2 row-cols-lg-4 stat-table">
              <MDBCol>
                <img src="images/icon_HP2.png" />
                <strong>HP</strong>
              </MDBCol>
              <MDBCol>
                <div class="spec-item" id="HP">{{ hp }}</div>
              </MDBCol>
              <MDBCol> </MDBCol>
              <MDBCol> </MDBCol>
              <MDBCol>
                <img src="images/icon_ATK2.png" />
                <strong>ATK</strong>
              </MDBCol>
              <MDBCol>
                <div class="spec-item" id="ATK">{{ atk }}</div>
              </MDBCol>
              <MDBCol>
                <img src="images/icon_CRT2.png" />
                <strong>CRIT</strong>
              </MDBCol>
              <MDBCol>
                <div class="spec-item" id="CRT">{{ info.CRT }}%</div>
              </MDBCol>
              <MDBCol>
                <img src="images/icon_DEF2.png" />
                <strong>DEF</strong>
              </MDBCol>
              <MDBCol>
                <div class="spec-item" id="DEF">{{ def }}</div>
              </MDBCol>
              <MDBCol>
                <img src="images/icon_HIT2.png" />
                <strong>ACC</strong>
              </MDBCol>
              <MDBCol>
                <div class="spec-item" id="HIT">{{ info.HIT }}%</div>
              </MDBCol>
              <MDBCol>
                <img src="images/icon_AGI.png" />
                <strong>SPD</strong>
              </MDBCol>
              <MDBCol>
                <div class="spec-item" id="AGI">{{ info.AGI }}</div>
              </MDBCol>
              <MDBCol>
                <img src="images/icon_DOD2.png" />
                <strong>EVA</strong>
              </MDBCol>
              <MDBCol>
                <div class="spec-item" id="DOD">{{ info.DOD }}%</div>
              </MDBCol>
              <MDBCol> <strong>Resists</strong></MDBCol>
              <MDBCol
                ><img src="images/fire.png" />{{ info.resist[0] }}%</MDBCol
              >
              <MDBCol><img src="images/ice.png" />{{ info.resist[1] }}%</MDBCol>
              <MDBCol>
                <img src="images/electric.png" />{{ info.resist[2] }}%
              </MDBCol>
            </MDBRow>
          </MDBCol>
        </MDBRow>
        <MDBRow>
          <MDBTabs v-model="activeTabId1">
            <!-- Tabs navs -->
            <MDBTabNav>
              <MDBTabItem
                v-for="ski in skill"
                :key="ski.title"
                :href="ski.title"
                :tabId="ski.title"
                ><img
                  :src="
                    'images/SkillIcon/' + ski.img + '_' + ski.type + '.png'
                  "
              /></MDBTabItem>
              <MDBTabItem href="info" tabId="info"
                ><img src="images/info.png" />
              </MDBTabItem>
            </MDBTabNav>
            <!-- Tabs navs -->
            <!-- Tabs content -->
            <MDBTabContent>
              <MDBTabPane
                v-for="ski in skill"
                :key="ski.title"
                :tabId="ski.title"
                class="m-3"
              >
                <skill-tab :data="ski" :atk="atk" />
              </MDBTabPane>
              <MDBTabPane
                href="info"
                tabId="info"
                class="m-3"
                v-html="info.info"
              >
              </MDBTabPane>
            </MDBTabContent>
            <!-- Tabs content -->
          </MDBTabs>
        </MDBRow>

        <MDBRow>
          <MDBCard style="width: 100%; margin: auto">
            <MDBCardHeader>Appeared In</MDBCardHeader>
            <MDBListGroup flush>
              <MDBListGroupItem
                v-for="(appear, index) in Object.keys(appearances)"
                :key="index"
              >
                <MDBCardTitle v-if="appear == 'NEW'">Sanctum of Alteration</MDBCardTitle>
                <MDBCardTitle v-else>{{ worldName(appear) }}</MDBCardTitle>
                <MDBCardText>
                  <MDBBtn v-if="appear == 'NEW'" color="danger" @click="moveSanctum()">Sanctum of Alteration</MDBBtn>
                  <MDBBtn v-else
                    color="primary"
                    v-for="zone in appearances[appear]"
                    :key="zone"
                    @click="moveStage(appear, zone[0], zone[1])"
                  >
                    {{ zone[1] }}
                  </MDBBtn>
                </MDBCardText>
              </MDBListGroupItem>
              <!-- <MDBListGroupItem v-if="sanctumAppeared">
                <MDBCardTitle>Sanctum of Alteration</MDBCardTitle>
                <MDBCardText>
                  <MDBBtn color="dark" @click="$router.push('/sanctum')">
                    Sanctum of Alteration
                  </MDBBtn>
                </MDBCardText>
              </MDBListGroupItem> -->
            </MDBListGroup>
            <div
              v-if="Object.keys(appearances).length == 0"
              class="text-muted"
            >
              No Appearances
            </div>
          </MDBCard>
        </MDBRow>
      </MDBModalBody>
    </MDBModal>
  </MDBContainer>
</template>

<script>
import SkillTab from "./SkillTab.vue";
import {
  MDBCol,
  MDBRow,
  MDBContainer,
  MDBModal,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBBtn,
  MDBTabs,
  MDBTabNav,
  MDBTabContent,
  MDBTabItem,
  MDBTabPane,
  MDBCard,
  MDBCardHeader,
  MDBCardTitle,
  MDBCardText,
  MDBListGroup,
  MDBListGroupItem,
  MDBInput,
} from "mdb-vue-ui-kit";
import { ref } from "vue";
// import { useStore } from "vuex";
import { ElSelect, ElOption } from "element-plus";

export default {
  components: {
    SkillTab,
    MDBCol,
    MDBRow,
    MDBContainer,
    MDBModal,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBBtn,
    MDBTabs,
    MDBTabNav,
    MDBTabContent,
    MDBTabItem,
    MDBTabPane,
    MDBCard,
    MDBCardHeader,
    MDBCardTitle,
    MDBCardText,
    MDBListGroup,
    MDBListGroupItem,
    MDBInput,
    ElSelect,
    ElOption,
  },
  name: "EnemyTab",
  props: {
    enemy: String,
    lvl: Number,
  },
  computed: {
    world() {
      return this.$store.getters.getWorld;
    },
    info0() {
      if (this.enemy2 in this.enemies) {
        return this.enemies[this.enemy2];
      } else if (this.enemy in this.enemies) {
        return this.enemies[this.enemy];
      }
      return {};
    },
    info() {
      if (this.enemy2 in this.enemies) {
        return require("../../public/data/enemies/" + this.enemy2);
      } else if (this.enemy in this.enemies) {
        return require("../../public/data/enemies/" + this.enemy);
      }
      return {};
    },
    hp() {
      return Math.floor(this.info.HP[0] + this.info.HP[1] * (this.level - 1));
    },
    atk() {
      return Math.floor(this.info.ATK[0] + this.info.ATK[1] * (this.level - 1));
    },
    def() {
      return Math.floor(this.info.DEF[0] + this.info.DEF[1] * (this.level - 1));
    },
    skill() {
      let ret = [];
      this.info.skills.forEach((element) => {
        if (this.skills[element]) {ret.push(this.skills[element])}
      });
      return ret;
    },
    appearances() {
      return this.info0.used;
    },
    duplicateEnemies() {
      var enemylist = this.$store.getters.getEnemies;
      var dupe = [];
      var name = this.info0.name;
      for (var key in enemylist) {
        var val = enemylist[key];
        if (val["name"] == name) {
          dupe.push([key, val]);
        }
      }
      return dupe;
    },
    // sanctumAppeared() {
    //   let enemy;
    //   if (this.enemy2 in this.enemies) {
    //     enemy = this.enemy2;
    //   } else {
    //     enemy = this.enemy;
    //   }
    //   var sanctum = this.$store.getters.getSanctum;
    //   for (var key in sanctum) {
    //     for (var key2 in sanctum[key]) {
    //       let stage = sanctum[key][key2];
    //       for (let id1 in stage["waves"]) {
    //         let wave = stage.waves[id1];
    //         for (let id2 in wave) {
    //           let pos = wave[id2].e;
    //           for (let e in pos) {
    //             if (pos[e]) {
    //               if (pos[e].id == enemy) {
    //                 return true;
    //               }
    //             }
    //           }
    //         }
    //       }
    //     }
    //   }
    //   return false;
    // },
  },
  data() {
    return {
      level: this.lvl,
      enemies: this.$store.getters.getEnemies,
      skills: this.$store.getters.getSkills,
      enemy2: this.enemy,
    };
  },
  methods: {
    updateEmit(e) {
      this.$emit("update", e);
    },
    moveStage(area, zone, stage) {
      document.body.classList.remove("modal-open");
      this.$router.replace(
        "/world/" + area + "/" + (parseInt(zone)).toString() + "/" + stage
      );
    },
    moveSanctum() {
      document.body.classList.remove("modal-open");
      this.$router.replace(
        "/sanctum/"
      );
    },
    changeEnemy(e) {
      this.enemy2 = e.target.value;
    },
    worldName(name) {
      if (name.charAt(0) == "S") {
        return this.world.story[name].title
      }
      else if (name.charAt(0) == "E") {
        return this.world.event[name].title
      }
      else {
        return this.world.others[name].title
      }
    },
  },
  async setup() {
    // const store = useStore();
    const enemyInfo = ref(false);
    const activeTabId1 = ref("askill1");
    // await store.dispatch("init");
    // await store.dispatch("requestMaps");
    return { enemyInfo, activeTabId1 };
  },
  updated() {
    if (this.enemy in this.enemies) {
      this.enemyInfo = true;
    } else {
      this.enemyInfo = false;
    }
    this.enemy2 = this.enemy;
    this.level = this.lvl;
    this.activeTabId1 = ref("askill1");
  },
  mounted() {
    if (this.enemy in this.enemies) {
      this.enemyInfo = true;
    } else {
      this.enemyInfo = false;
    }
    this.activeTabId1 = ref("askill1");
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.nav-link img {
  height: 60px;
  padding-top: 5px;
  padding-bottom: 5px;
}
.stat-table {
  width: 100%;
  height: 100%;
  text-align: left;
}
.stat-table div {
  display: inline;
}
.stat-table img {
  max-width: 1.5em;
  display: inline;
  vertical-align: middle;
  margin-right: 0.2em;
}
.image img {
  width: 128px;
}
.tab-content {
  border: 1px solid #e0e0e0;
}
</style>

<style scoped>
.stats {
  margin: 20px;
}
.tab-pane {
  text-align: left;
}
.card-header {
  font-size: 21px;
}
</style>
